import loadable from '@loadable/component'

export default [
  {
    path: '/welfareDay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-welfareDay-index" */ '~/pages/welfareDay/index'
        )
    ),
  },
  {
    path: '/welfareDay/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-welfareDay-rule" */ '~/pages/welfareDay/rule'
        )
    ),
  },
]
